export const NOTIFICATION_LIST_VIEW: string = 'notification-list.view';
export const COMMENT_LIST_VIEW: string = 'comment-list.view';
export const EMAIL_NOTIFICATION_LIST_VIEW: string = 'email-notification-list.view';
export const SETTINGS_ACCOUNT_VIEW: string = 'settings-account.view';
export const SETTINGS_ACCOUNT_EDIT: string = 'settings-account.edit';
export const SETTINGS_USER_LIST_VIEW: string = 'settings-user-list.view';
export const SETTINGS_USER_VIEW: string = 'settings-user.view';
export const SETTINGS_USER_CREATE: string = 'settings-user.create';
export const SETTINGS_USER_EDIT: string = 'settings-user.edit';
export const SETTINGS_USER_INVITE_CREATE: string = 'settings-user-invite.create';
export const SETTINGS_USER_DELETE: string = 'settings-user.delete';
export const SETTINGS_PROFILE_VIEW: string = 'settings-profile.view';
export const SETTINGS_PROFILE_EDIT: string = 'settings-profile.edit';
export const SETTINGS_NOTIFICATION_VIEW: string = 'settings-notification.view';
export const SETTINGS_NOTIFICATION_EDIT: string = 'settings-notification.edit';
export const SETTINGS_OPERATION_LOG_VIEW: string = 'settings-operation-log.view';
export const ERROR_MESSAGE_LIST_VIEW: string = 'error-message-list.view';
export const DEAL_TEMPLATE_LIST_VIEW: string = 'deal-template-list.view';
export const DEAL_TEMPLATE_CREATE: string = 'deal-template.create';
export const DEAL_TEMPLATE_DELETE: string = 'deal-template.delete';
export const DEAL_TEMPLATE_EDIT: string = 'deal-template.edit';
export const SEARCH_RESULT_VIEW: string = 'search-result.view';
export const CONTENT_PAGE_VIEW: string = 'content-page.view';
export const DASHBOARD_VIEW: string = 'dashboard.view';
export const DASHBOARD_PORTFOLIO_FILTER_VIEW: string = 'dashboard-portfolio-filter.view';
export const DASHBOARD_STATISTICS_VIEW: string = 'dashboard-statistics.view';
export const DASHBOARD_ACCOUNT_SUMMARY_VIEW: string = 'dashboard-account-summary.view';
export const DASHBOARD_ASSET_LOCATIONS_VIEW: string = 'dashboard-asset-locations.view';
export const DASHBOARD_DEAL_SOURCES_VIEW: string = 'dashboard-deal-sources.view';
export const DASHBOARD_DEALS_IN_DUE_DILIGENCE_VIEW: string = 'dashboard-deals-in-due-diligence.view';
export const DASHBOARD_RECENT_DEAL_UPDATES_VIEW: string = 'dashboard-recent-deal-updates.view';
export const DASHBOARD_USER_DEAL_TASKS_VIEW: string = 'dashboard-user-deal-tasks.view';
export const DASHBOARD_USER_MENTIONS_VIEW: string = 'dashboard-user-mentions.view';
export const DASHBOARD_NEW_DEALS_BY_PERIOD_VIEW: string = 'dashboard-new-deals-by-period.view';
export const DASHBOARD_DEAD_DEAL_REASONS_VIEW: string = 'dashboard-dead-deal-reasons.view';
export const DASHBOARD_DEALS_BY_MSA_VIEW: string = 'dashboard-deals-by-msa.view';
export const DASHBOARD_DEALS_BY_TYPE_VIEW: string = 'dashboard-deals-by-type.view';
export const DASHBOARD_DEAL_PIPELINE_FUNNEL_VIEW: string = 'dashboard-deal-pipeline-funnel.view';
export const PORTFOLIO_LIST_VIEW: string = 'portfolio-list.view';
export const PORTFOLIO_CREATE: string = 'portfolio.create';
export const PORTFOLIO_EDIT: string = 'portfolio.edit';
export const PORTFOLIO_DELETE: string = 'portfolio.delete';
export const ASSET_LIST_VIEW: string = 'asset-list.view';
export const ASSET_LIST_ASSET_LOCATIONS_VIEW: string = 'asset-list-asset-locations.view';
export const ASSET_PORTFOLIO_FILTER_VIEW: string = 'asset-portfolio-filter.view';
export const ASSET_STATISTICS_VIEW: string = 'asset-statistics.view';
export const ASSET_VIEW: string = 'asset.view';
export const ASSET_CREATE: string = 'asset.create';
export const ASSET_EDIT: string = 'asset.edit';
export const ASSET_DELETE: string = 'asset.delete';
export const ASSET_LIST_IMPORT: string = 'asset-list.import';
export const ASSET_LIST_EXPORT: string = 'asset-list.export';
export const ACTIVITY_LIST_VIEW: string = 'activity-list.view';
export const ACTIVITY_PORTFOLIO_FILTER_VIEW: string = 'activity-portfolio-filter.view';
export const ACTIVITY_STATUS_FILTER_VIEW: string = 'activity-status-filter.view';
export const ACTIVITY_CREATE: string = 'activity.create';
export const ACTIVITY_EDIT: string = 'activity.edit';
export const ACTIVITY_DELETE: string = 'activity.delete';
export const ACTIVITY_LIST_IMPORT: string = 'activity-list.import';
export const ACTIVITY_LIST_EXPORT: string = 'activity-list.export';
export const ACTIVITY_STATUS_EDIT: string = 'activity-status.edit';
export const ACTIVITY_ATTACHMENT_LIST_VIEW: string = 'activity-attachment-list.view';
export const ACTIVITY_COMMENT_LIST_VIEW: string = 'activity-comment-list.view';
export const ACTIVITY_COMMENT_CREATE: string = 'activity-comment.create';
export const ACTIVITY_COMMENT_DELETE: string = 'activity-comment.delete';
export const ACTIVITY_COMMENT_EDIT: string = 'activity-comment.edit';
export const CONTACT_LIST_VIEW: string = 'contact-list.view';
export const CONTACT_VIEW: string = 'contact.view';
export const CONTACT_CREATE: string = 'contact.create';
export const CONTACT_EDIT: string = 'contact.edit';
export const CONTACT_DELETE: string = 'contact.delete';
export const CONTACT_LIST_IMPORT: string = 'contact-list.import';
export const CONTACT_LIST_EXPORT: string = 'contact-list.export';
export const CONTACT_COMMENT_LIST_VIEW: string = 'contact-comment-list.view';
export const CONTACT_COMMENT_CREATE: string = 'contact-comment.create';
export const CONTACT_COMMENT_DELETE: string = 'contact-comment.delete';
export const CONTACT_COMMENT_EDIT: string = 'contact-comment.edit';
export const CONTACT_ATTACHMENT_LIST_VIEW: string = 'contact-attachment-list.view';
export const DEAL_LIST_VIEW: string = 'deal-list.view';
export const DEAL_LIST_PORTFOLIO_FILTER_VIEW: string = 'deal-list-portfolio-filter.view';
export const DEAL_LIST_DEAL_LOCATIONS_VIEW: string = 'deal-list-deal-locations.view';
export const DEAL_LIST_IMPORT: string = 'deal-list.import';
export const DEAL_LIST_EXPORT: string = 'deal-list.export';
export const DEAL_STATUS_EDIT: string = 'deal-status.edit';
export const DEAL_VIEW: string = 'deal.view';
export const DEAL_CREATE: string = 'deal.create';
export const DEAL_DELETE: string = 'deal.delete';
export const DEAL_IMPORT: string = 'deal.import';
export const DEAL_EXPORT: string = 'deal.export';
export const DEAL_COMMON_EDIT: string = 'deal-common.edit';
export const DEAL_SUMMARY_VIEW: string = 'deal-summary.view';
export const DEAL_CAPITALIZATION_VIEW: string = 'deal-capitalization.view';
export const DEAL_CAPITALIZATION_IMPORT: string = 'deal-capitalization.import';
export const DEAL_CAPITALIZATION_EXPORT: string = 'deal-capitalization.export';
export const DEAL_TERMS_VIEW: string = 'deal-terms.view';
export const DEAL_TERMS_IMPORT: string = 'deal-terms.import';
export const DEAL_TERMS_EXPORT: string = 'deal-terms.export';
export const DEAL_PRO_FORMA_VIEW: string = 'deal-pro-forma.view';
export const DEAL_PRO_FORMA_EXPORT: string = 'deal-pro-forma.export';
export const DEAL_SCHEDULE_VIEW: string = 'deal-schedule.view';
export const DEAL_DUE_DILIGENCE_VIEW: string = 'deal-due-diligence.view';
export const DEAL_DUE_DILIGENCE_IMPORT: string = 'deal-due-diligence.import';
export const DEAL_DUE_DILIGENCE_EXPORT: string = 'deal-due-diligence.export';
export const DEAL_PARTICIPANTS_VIEW: string = 'deal-participants.view';
export const DEAL_PARTICIPANTS_IMPORT: string = 'deal-participants.import';
export const DEAL_PARTICIPANTS_EXPORT: string = 'deal-participants.export';
export const DEAL_FILES_VIEW: string = 'deal-files.view';
export const DEAL_FILES_EXPORT: string = 'deal-files.export';
export const DEAL_COMMENTS_VIEW: string = 'deal-comments.view';
export const DEAL_PHOTO_LIST_VIEW: string = 'deal-photo-list.view';
export const DEAL_PHOTO_CREATE: string = 'deal-photo.create';
export const DEAL_PHOTO_EDIT: string = 'deal-photo.edit';
export const DEAL_PHOTO_DELETE: string = 'deal-photo.delete';
export const DEAL_BUILDING_DETAILS_LIST_VIEW: string = 'deal-building-details-list.view';
export const DEAL_BUILDING_DETAILS_ITEM_CREATE: string = 'deal-building-details-item.create';
export const DEAL_BUILDING_DETAILS_ITEM_EDIT: string = 'deal-building-details-item.edit';
export const DEAL_BUILDING_DETAILS_ITEM_DELETE: string = 'deal-building-details-item.delete';
export const DEAL_MILESTONES_ITEM_CREATE: string = 'deal-milestones-item.create';
export const DEAL_MILESTONES_ITEM_EDIT: string = 'deal-milestones-item.edit';
export const DEAL_MILESTONES_ITEM_DELETE: string = 'deal-milestones-item.delete';
export const DEAL_EXTERNAL_LINKS_LIST_VIEW: string = 'deal-external-links-list.view';
export const DEAL_EXTERNAL_LINKS_ITEM_CREATE: string = 'deal-external-links-item.create';
export const DEAL_EXTERNAL_LINKS_ITEM_EDIT: string = 'deal-external-links-item.edit';
export const DEAL_EXTERNAL_LINKS_ITEM_DELETE: string = 'deal-external-links-item.delete';
export const DEAL_CONTACTS_GROUP_LIST_VIEW: string = 'deal-contacts-group-list.view';
export const DEAL_CONTACTS_GROUP_ITEM_CREATE: string = 'deal-contacts-group-item.create';
export const DEAL_CONTACTS_GROUP_ITEM_EDIT: string = 'deal-contacts-group-item.edit';
export const DEAL_CONTACTS_GROUP_ITEM_DELETE: string = 'deal-contacts-group-item.delete';
export const DEAL_CONTACTS_LIST_VIEW: string = 'deal-contacts-list.view';
export const DEAL_CONTACTS_ITEM_CREATE: string = 'deal-contacts-item.create';
export const DEAL_CONTACTS_ITEM_EDIT: string = 'deal-contacts-item.edit';
export const DEAL_CONTACTS_ITEM_DELETE: string = 'deal-contacts-item.delete';
export const DEAL_SOURCES_LIST_VIEW: string = 'deal-sources-list.view';
export const DEAL_SOURCES_ITEM_CREATE: string = 'deal-sources-item.create';
export const DEAL_SOURCES_ITEM_EDIT: string = 'deal-sources-item.edit';
export const DEAL_SOURCES_ITEM_DELETE: string = 'deal-sources-item.delete';
export const DEAL_USES_LIST_VIEW: string = 'deal-uses-list.view';
export const DEAL_USES_ITEM_CREATE: string = 'deal-uses-item.create';
export const DEAL_USES_ITEM_EDIT: string = 'deal-uses-item.edit';
export const DEAL_USES_ITEM_DELETE: string = 'deal-uses-item.delete';
export const DEAL_EQUITY_ORGANIZATION_CHART_VIEW: string = 'deal-equity-organization-chart.view';
export const DEAL_EQUITY_ORGANIZATION_CHART_EDIT: string = 'deal-equity-organization-chart.edit';
export const DEAL_EQUITY_ORGANIZATION_CHART_DELETE: string = 'deal-equity-organization-chart.delete';
export const DEAL_METRICS_CAPITAL_STACK_LIST_VIEW: string = 'deal-metrics-capital-stack-list.view';
export const DEAL_METRICS_CAPITAL_STACK_ITEM_EDIT: string = 'deal-metrics-capital-stack-item.edit';
export const DEAL_METRICS_STATISTICS_LIST_VIEW: string = 'deal-metrics-statistics-list.view';
export const DEAL_METRICS_STATISTICS_ITEM_CREATE: string = 'deal-metrics-statistics-item.create';
export const DEAL_METRICS_STATISTICS_ITEM_EDIT: string = 'deal-metrics-statistics-item.edit';
export const DEAL_METRICS_STATISTICS_ITEM_DELETE: string = 'deal-metrics-statistics-item.delete';
export const DEAL_TERM_GROUP_LIST_VIEW: string = 'deal-term-group-list.view';
export const DEAL_TERM_GROUP_CREATE: string = 'deal-term-group.create';
export const DEAL_TERM_GROUP_EDIT: string = 'deal-term-group.edit';
export const DEAL_TERM_GROUP_DELETE: string = 'deal-term-group.delete';
export const DEAL_TERM_LIST_VIEW: string = 'deal-term-list.view';
export const DEAL_TERM_CREATE: string = 'deal-term.create';
export const DEAL_TERM_EDIT: string = 'deal-term.edit';
export const DEAL_TERM_DELETE: string = 'deal-term.delete';
export const DEAL_HISTORICAL_VALUATIONS_LIST_VIEW: string = 'deal-historical-valuations-list.view';
export const DEAL_HISTORICAL_VALUATIONS_CREATE: string = 'deal-historical-valuations.create';
export const DEAL_HISTORICAL_VALUATIONS_EDIT: string = 'deal-historical-valuations.edit';
export const DEAL_HISTORICAL_VALUATIONS_DELETE: string = 'deal-historical-valuations.delete';
export const DEAL_TOP_LEVEL_METRICS_LIST_VIEW: string = 'deal-top-level-metrics-list.view';
export const DEAL_TOP_LEVEL_METRICS_CREATE: string = 'deal-top-level-metrics.create';
export const DEAL_TOP_LEVEL_METRICS_EDIT: string = 'deal-top-level-metrics.edit';
export const DEAL_TOP_LEVEL_METRICS_DELETE: string = 'deal-top-level-metrics.delete';
export const DEAL_VALUATION_FILE_GROUP_LIST_VIEW: string = 'deal-valuation-file-group-list.view';
export const DEAL_VALUATION_FILE_LIST_VIEW: string = 'deal-valuation-file-list.view';
export const DEAL_VALUATION_FILE_CREATE: string = 'deal-valuation-file.create';
export const DEAL_VALUATION_FILE_EDIT: string = 'deal-valuation-file.edit';
export const DEAL_VALUATION_FILE_DELETE: string = 'deal-valuation-file.delete';
export const DEAL_TASK_GROUP_LIST_VIEW: string = 'deal-task-group-list.view';
export const DEAL_TASK_GROUP_CREATE: string = 'deal-task-group.create';
export const DEAL_TASK_GROUP_EDIT: string = 'deal-task-group.edit';
export const DEAL_TASK_GROUP_DELETE: string = 'deal-task-group.delete';
export const DEAL_TASK_LIST_VIEW: string = 'deal-task-list.view';
export const DEAL_TASK_CREATE: string = 'deal-task.create';
export const DEAL_TASK_EDIT: string = 'deal-task.edit';
export const DEAL_TASK_DELETE: string = 'deal-task.delete';
export const DEAL_TASK_STATUS_EDIT: string = 'deal-task-status.edit';
export const DEAL_TASK_ATTACHMENT_LIST_VIEW: string = 'deal-task-attachment-list.view';
export const DEAL_TASK_COMMENT_LIST_VIEW: string = 'deal-task-comment-list.view';
export const DEAL_TASK_COMMENT_CREATE: string = 'deal-task-comment.create';
export const DEAL_TASK_COMMENT_EDIT: string = 'deal-task-comment.edit';
export const DEAL_TASK_COMMENT_DELETE: string = 'deal-task-comment.delete';
export const DEAL_TASK_ACCESS_LEVEL_VIEW: string = 'deal-task-access-level.view';
export const DEAL_SCHEDULE_CREATE: string = 'deal-schedule.create';
export const DEAL_SCHEDULE_EDIT: string = 'deal-schedule.edit';
export const DEAL_SCHEDULE_DELETE: string = 'deal-schedule.delete';
export const DEAL_SCHEDULE_TASK_LIST_VIEW: string = 'deal-schedule-task-list.view';
export const DEAL_SCHEDULE_TASK_CREATE: string = 'deal-schedule-task.create';
export const DEAL_SCHEDULE_TASK_EDIT: string = 'deal-schedule-task.edit';
export const DEAL_SCHEDULE_TASK_DELETE: string = 'deal-schedule-task.delete';
export const DEAL_PARTICIPANT_GROUP_LIST_VIEW: string = 'deal-participant-group-list.view';
export const DEAL_PARTICIPANT_LIST_VIEW: string = 'deal-participant-list.view';
export const DEAL_PARTICIPANT_CREATE: string = 'deal-participant.create';
export const DEAL_PARTICIPANT_EDIT: string = 'deal-participant.edit';
export const DEAL_PARTICIPANT_DELETE: string = 'deal-participant.delete';
export const DEAL_PARTICIPANT_ACCESS_LEVEL_VIEW: string = 'deal-participant-access-level.view';
export const DEAL_PARTICIPANT_APPROVAL_VIEW: string = 'deal-participant-approval.view';
export const DEAL_PARTICIPANT_COMMENT_LIST_VIEW: string = 'deal-participant-comment-list.view';
export const DEAL_PARTICIPANT_COMMENT_CREATE: string = 'deal-participant-comment.create';
export const DEAL_PARTICIPANT_COMMENT_EDIT: string = 'deal-participant-comment.edit';
export const DEAL_PARTICIPANT_COMMENT_DELETE: string = 'deal-participant-comment.delete';
export const DEAL_PARTICIPANT_ATTACHMENT_LIST_VIEW: string = 'deal-participant-attachment-list.view';
export const DEAL_FILE_GROUP_LIST_VIEW: string = 'deal-file-group-list.view';
export const DEAL_FILE_GROUP_CREATE: string = 'deal-file-group.create';
export const DEAL_FILE_GROUP_EDIT: string = 'deal-file-group.edit';
export const DEAL_FILE_GROUP_DELETE: string = 'deal-file-group.delete';
export const DEAL_FILE_LIST_VIEW: string = 'deal-file-list.view';
export const DEAL_FILE_CREATE: string = 'deal-file.create';
export const DEAL_FILE_EDIT: string = 'deal-file.edit';
export const DEAL_FILE_DELETE: string = 'deal-file.delete';
export const DEAL_FILE_ACCESS_LEVEL_VIEW: string = 'deal-file-access-level.view';
export const DEAL_FILE_TEXT_DATA_VIEW: string = 'deal-file-text-data.view';
export const REPORT_LIST_VIEW: string = 'report-list.view';
export const REPORT_VIEW: string = 'report.view';
export const REPORT_DELETE: string = 'report.delete';
export const REPORT_CREATE: string = 'report.create';
export const REPORT_EDIT: string = 'report.edit';
export const PORTFOLIO_GROUP_LIST_VIEW: string = 'portfolio-group-list.view';
export const PORTFOLIO_GROUP_CREATE: string = 'portfolio-group.create';
export const PORTFOLIO_GROUP_EDIT: string = 'portfolio-group.edit';
export const PORTFOLIO_GROUP_DELETE: string = 'portfolio-group.delete';
export const ACCOUNT_LIST_VIEW: string = 'account-list.view';
export const ACCOUNT_CREATE: string = 'account.create';
export const ACCOUNT_DELETE: string = 'account.delete';
export const ACCOUNT_DEAL_STATUS_EDIT: string = 'account-deal-status.edit';
export const ACCOUNT_DEAL_TASK_STATUS_EDIT: string = 'account-deal-task-status.edit';
export const ACCOUNT_ACTIVITY_STATUS_EDIT: string = 'account-activity-status.edit';
export const ACCOUNT_DEAL_REJECT_REASON_EDIT: string = 'account-deal-reject-reason.edit';
